import { setIgnitionMinimum } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { IgnitionMinimum } from '@customer/store/apis/healthApi';
import SingleSelectFilter from './SingleSelectFilter';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { useMemo } from 'react';

const useIgnitionMinimumOptions = (): DropdownItemProps<IgnitionMinimum>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return Object.keys(IgnitionMinimum).map((key: string) => {
      const value = IgnitionMinimum[key as keyof typeof IgnitionMinimum];
      return {
        key: value,
        value,
        stringValue: value,
        label: t(`filters.IgnitionMinimum.${key}`),
      };
    });
  }, [t]);
};

export const IgnitionMinimumFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownElement>) => {
  const { t } = useTranslation();

  return (
    <SingleSelectFilter<IgnitionMinimum>
      filterName="ignitionMinimum"
      label={label ?? t('IgnitionOnTime')}
      elementRef={elementRef}
      action={setIgnitionMinimum}
      useItemsHook={useIgnitionMinimumOptions}
    />
  );
};

export default IgnitionMinimumFilter;
